import React, { useState } from "react";
import { FmImage } from "@/ui-component";
import VideoProductItem from "./VideoProductItem";
import styles from "./videoProductItem.module.scss";
import SizeConversionCanvas from "@/src/productDetails/SizeChart/SizeConversionCanvas";
import CustomCarousel from "./CustomCarousel/index";

interface BTemplateContentProps {
    contentList: any[];
    activeIndex: number;
    updateCurrentIndex: (index: number) => void;
    isPlaying?: boolean;
}

const BTemplateContent: React.FC<BTemplateContentProps> = ({
    contentList,
    updateCurrentIndex,
    activeIndex,
    isPlaying
}) => {
    const [isInches, setIsInches] = useState(false);
    return (
        <CustomCarousel
            dots={true}
            index={activeIndex}
            onChangeIndex={updateCurrentIndex}
            autoplay={isPlaying} 
            interval={2000} // 2秒切换
            infinite={true}
            contentList={contentList}
        >
            {contentList.map((item, index) => {
                if (item.video_url) {
                    return (
                        <VideoProductItem
                            key={index}
                            products_video_list={[item]}
                            rowID={1}
                        ></VideoProductItem>
                    );
                }
                if (typeof item === "string") {
                    return (
                        <div className={styles.Bcontainer} key={index}> 
                            <FmImage                         
                            image={item}
                        ></FmImage>
                        </div>
                    );
                }
                return (
                    <div
                        key={index + item.type}
                        className={"default_layout"}
                        style={{ width: "100vw", height: "100%" }}
                    >
                        <SizeConversionCanvas
                            canvasData={item}
                            isHideInchInCaontainer={false}
                            isInches={isInches}
                            onChangeShowType={() => {
                                setIsInches(!isInches);
                            }}
                            backgroundColor={"#F2f2f2"}
                        ></SizeConversionCanvas>
                    </div>
                );
            })}
        </CustomCarousel>
    );
};

export default BTemplateContent;
